import * as z from 'zod'
const stringRequired = (message: string) => z.string({ required_error: message }).min(1, message)
const numberRequired = (message: string) => z.number({ required_error: message }).min(1, message)
const yarnTypeRequired = (message: string) => z.number({ required_error: message }).min(0, message)
export const mergeSchema = z.object({
  mergeNumber:stringRequired('Merge number is required!'),
  yarnType: yarnTypeRequired('Yarn type is required!'),
  yarnColour: stringRequired('Yarn colour is required!'),
  yarnCount: stringRequired('Yarn count is required!'),
  costPerKgAmount:numberRequired('Cost per kilogram is required!'),
  costPerKgCurrency: z.number().optional(),
  supplierId: stringRequired('Supplier is required!'),
  totalKgOrdered: numberRequired('Total kilogram ordered is required!'),
  totalCostAmount: z.number().nullish(),
  totalCostCurrency: z.number().nullish(),
  kgAvailable: numberRequired('Available kilogram is required!'),
  totalPercentageUsed: z.number().optional(),
  totalPercentageWasted: z.number().optional()
})
